import * as gfunctions from '../../../js/generalFunctions';

CCL.Dining = {
  autoload: [
    ['adultincrement', $('#diningAtcModal').length > 0],
    ['childincrement', $('#diningAtcModal').length > 0],
    ['adultdecrement', $('#diningAtcModal').length > 0],
    ['childdecrement', $('#diningAtcModal').length > 0],
    ['dropdownSelect', $('#diningAtcModal').length > 0],
    ['priceShow', $('#diningAtcModal').length > 0],
    ['addToCartDining', $('#diningAtcModal').length > 0]
  ],

  adultincrement() {
    $('body').on('click keypress', '.adult-increment-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.adult-decrement-btn').css('opacity', '1');
        $('.adult-decrement-btn').css('pointer-events', 'auto');
        let maxcount = '';
        const capAmount = Number($('#diningCapAmount').val());
        const diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          const childVal = $('.child-quantity-input').val();
          let adultVal = $('.adult-quantity-input').val();
          if (adultVal < maxcount - childVal) {
            adultVal++;
            console.dir(event.currentTarget.previousElementSibling);
            event.currentTarget.previousElementSibling.firstElementChild.value = adultVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', `adult quantity value is ${adultVal}`);
            $(event.target).attr('aria-label', `increase adult quantity with current value ${adultVal}`);
            $(event.target).parents('.adult-quantity-wrap').find('.adult-decrement-btn').attr('aria-label', `decrease adult quantity with current value ${adultVal}`);
          } else {
            $('.adult-increment-btn').css('opacity', '0.5');
            $('.adult-increment-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  childincrement() {
    $('body').on('click keypress', '.child-increment-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.child-decrement-btn').css('opacity', '1');
        $('.child-decrement-btn').css('pointer-events', 'auto');
        let maxcount = '';
        const capAmount = Number($('#diningCapAmount').val());
        const diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          let childVal = $('.child-quantity-input').val();
          const adultVal = $('.adult-quantity-input').val();
          if (childVal < maxcount - adultVal) {
            childVal++;
            event.currentTarget.previousElementSibling.firstElementChild.value = childVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', `child quantity value is ${childVal}`);
            $(event.target).attr('aria-label', `increase child quantity with current value ${childVal}`);
            $(event.target).parents('.child-quantity-wrap').find('.child-decrement-btn').attr('aria-label', `decrease child quantity with current value ${childVal}`);
          } else {
            $('.child-increment-btn').css('opacity', '0.5');
            $('.child-increment-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  adultdecrement() {
    $('body').on('click keypress', '.adult-decrement-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.adult-increment-btn').css('opacity', '1');
        $('.adult-increment-btn').css('pointer-events', 'auto');
        let maxcount = '';
        const capAmount = Number($('#diningCapAmount').val());
        const diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          const childVal = $('.child-quantity-input').val();
          let adultVal = $('.adult-quantity-input').val();
          if (adultVal > 1) {
            adultVal--;
            event.currentTarget.nextElementSibling.firstElementChild.value = adultVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', `quantity value is ${adultVal}`);
            $(event.target).attr('aria-label', `decrease adult quantity with current value ${adultVal}`);
            $(event.target).parents('.adult-quantity-wrap').find('.adult-increment-btn').attr('aria-label', `increase adult quantity with current value ${adultVal}`);
          } if (childVal < maxcount - adultVal) {
            $('.child-increment-btn').css('opacity', '1');
            $('.child-increment-btn').css('pointer-events', 'auto');
          } if (adultVal <= 1) {
            $('.adult-decrement-btn').css('opacity', '0.5');
            $('.adult-decrement-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  childdecrement() {
    $('body').on('click keypress', '.child-decrement-btn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.child-increment-btn').css('opacity', '1');
        $('.child-increment-btn').css('pointer-events', 'auto');
        let maxcount = '';
        const capAmount = Number($('#diningCapAmount').val());
        const diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          let childVal = $('.child-quantity-input').val();
          const adultVal = $('.adult-quantity-input').val();
          if (childVal > 0) {
            childVal--;
            event.currentTarget.nextElementSibling.firstElementChild.value = childVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', `quantity value is ${childVal}`);
            $(event.target).attr('aria-label', `decrease child quantity with current value ${childVal}`);
            $(event.target).parents('.child-quantity-wrap').find('.child-increment-btn').attr('aria-label', `increase child quantity with current value ${childVal}`);
          } if (adultVal < maxcount - childVal) {
            $('.adult-increment-btn').css('opacity', '1');
            $('.adult-increment-btn').css('pointer-events', 'auto');
          } if (childVal <= 0) {
            $('.child-decrement-btn').css('opacity', '0.5');
            $('.child-decrement-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  priceShow() {
    if ($('body').find('.c-pdp-template-reserve-dining #adultVariantPrice').length || $('body').find('#diningAtcModal #adultVariantPrice').length) {
      const priceAdult = $('#adultVariantPrice').val();
      const priceChild = $('#childVariantPrice').val();
      if (priceAdult === priceChild && (priceAdult !== '' && priceChild !== '')) {
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').hide();
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').addClass('show');
        $('.c-pdp-template-reserve-dining #personPrice,#diningAtcModal #personPrice').val(priceAdult);
      } else if (priceAdult !== '' && priceChild === '') {
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').addClass('show');
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').hide();
        $('.c-pdp-template-reserve-dining #personPrice,#diningAtcModal #personPrice').val(priceAdult);
      } else {
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').addClass('show');
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').hide();
      }
    }
  },
  dropdownSelect() {
    const noDayTimeSlotsAvailable = $('#noDayTimeSlotsAvailable').val();
    const diningStock = Number($('#diningStock').val());
    const chefProduct = $('#isLiveChefProduct').val();
    $('.select-day-dropdown.dining .dropdown-toggle').attr('aria-live', 'assertive');
    $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-live', 'assertive');
    if (noDayTimeSlotsAvailable === 'true' || noDayTimeSlotsAvailable === true) {
      $('.adult-child-wrap').hide();
      $('.day-time-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
    } else if (diningStock === 0 && chefProduct === '') {
      $('.adult-child-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
    } else if (diningStock === 0 && chefProduct === 'true') {
      $('.adult-child-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
      $('.day-time-wrap').hide();
      $('.reservation-pill').hide();
    }
    $('body').on('click keypress', '.select-day-dropdown.dining .dropdown-item', (e) => {
      gfunctions.showLoader();
      console.dir($(e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling)[0].children[0].innerText);
      $(e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling)[0].children[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      $('.adult-quantity-input').val('1');
      $('.child-quantity-input').val('0');
      const selectedDataId = e.currentTarget.dataset.dayid;
      $('.select-day-dropdown.dining #select-day')[0].dataset.selectedday = selectedDataId;
      $('.select-day-dropdown.dining .dropdown-toggle').addClass('ada-highlighted');
      const selectDay = e.currentTarget.innerText;
      $('.select-day-dropdown.dining .dropdown-toggle').attr('aria-label', `Select day: ${selectDay} selected`);
      setTimeout(() => {
        $('.select-day-dropdown.dining .dropdown-toggle').focus();
      }, 100);
      const parentProdCode = $('#parent-product-code').val();
      const dataObj = {
        parentProductCode: parentProdCode,
        selectedDay: selectedDataId
      };
      $.ajax({
        type: 'GET',
        url: '/shop/getTimeSlots',
        contentType: 'application/json',
        data: dataObj
      }).done((res) => {
        gfunctions.hideLoader();
        $('.diningErrorMsg').html('');
        if (!($.isEmptyObject(res))) {
          $('.atc-dining').removeAttr('disabled');
          $('.sold-out').removeClass('show');
          $('.adult-child-wrap').show();
          $('.select-time-dropdown.dining').show();
          let tempHtml = '';
          let preSelectedTimeKey = '';
          let preSelectedTimeValue = '';
          $.each(res, (key, value) => {
            if (preSelectedTimeKey === '' && preSelectedTimeValue === '') {
              preSelectedTimeKey = key;
              preSelectedTimeValue = value;
              $.ajax({
                type: 'GET',
                url: '/shop/getUpdatedPriceForDining',
                contentType: 'application/json',
                data: { variantId: preSelectedTimeKey }
              }).done((response) => {
                gfunctions.hideLoader();
                const updatestock = $('#diningStock');
                updatestock.val(Number(response.stockLevel));
                if (Number(updatestock.val()) !== 0) {
                  if (response.priceForAdult === response.priceForChild && (response.priceForAdult !== '' && response.priceForChild !== '')) {
                    $('.price-per-person #personPrice').html(response.priceForAdult);
                    $('.per-price').hide();
                    $('.price-per-person').show();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutAdultVariantPrice) {
                      if ($('.price-per-person .strikeoutprice').length > 0) {
                        $('.price-per-person .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                      } else {
                        $('.price-per-person #personPrice').before(`<span class="strikeoutprice">${response.strikeOutAdultVariantPrice}</span`);
                      }
                    }
                  } else if (response.priceForAdult !== '' && response.priceForChild === '') {
                    $('.price-per-person #personPrice').html(response.priceForAdult);
                    $('.per-price').hide();
                    $('.price-per-person').show();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutAdultVariantPrice) {
                      if ($('.price-per-person .strikeoutprice').length > 0) {
                        $('.price-per-person .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                      } else {
                        $('.price-per-person #personPrice').before(`<span class="strikeoutprice">${response.strikeOutAdultVariantPrice}</span`);
                      }
                    }
                  } else {
                    $('.per-price #adultPrice').html(response.priceForAdult);
                    $('.per-price #childPrice').html(response.priceForChild);
                    $('.per-price').show();
                    $('.price-per-person').hide();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutChildVariantPrice > 0) {
                      if ($('.per-price .strikeoutprice').length > 0) {
                        $('.price-per-adult .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                        $('.price-per-child .strikeoutprice').html(response.strikeOutChildVariantPrice);
                      } else {
                        $('.price-per-adult #adultPrice').before(`<span class="strikeoutprice">${response.strikeOutAdultVariantPrice}</span`);
                        $('.price-per-child #childPrice').before(`<span class="strikeoutprice">${response.strikeOutChildVariantPrice}</span`);
                      }
                    }
                  }
                } else {
                  $('.adult-child-wrap').hide();
                  $('.atc-dining').attr('disabled', 'disabled');
                  $('.sold-out').addClass('show');
                  $('.per-price').hide();
                  $('.price-per-person').hide();
                }
              });
            }
            tempHtml += `<button id="${key}" class="dropdown-item"  data-variantid="${key}" type="button">${value}</button>`;
          });
          gfunctions.hideLoader();
          $('.select-time-dropdown.dining #select-time').data('variantid', preSelectedTimeKey);
          $('.select-time-dropdown.dining #select-time>span').html(preSelectedTimeValue);
          $('.select-time-dropdown.dining .dropdown-menu .simplebar-content').empty().html(tempHtml);
          $('#variantProductCode').val(preSelectedTimeKey);
        } else {
          $('.atc-dining').attr('disabled', 'disabled');
          $('.sold-out').addClass('show');
          $('.adult-child-wrap').hide();
          $('.select-time-dropdown.dining').hide();
          $('.per-price').hide();
          $('.price-per-person').hide();
        }
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('Something went wrong in day-dropdown ajax');
      });
    });
    $('body').on('click keypress', '.select-time-dropdown.dining .dropdown-item', (e) => {
      gfunctions.showLoader();
      $('.adult-quantity-input').val('1');
      $('.child-quantity-input').val('0');
      const selectedVariantId = $(e.currentTarget).data('variantid');
      $('.select-time-dropdown.dining #select-time').attr('data-variantid', selectedVariantId);
      console.dir($('.select-time-dropdown.dining #select-time>span'));
      $('.select-time-dropdown.dining #select-time>span').html($(e.currentTarget).html());
      $('.select-time-dropdown.dining .dropdown-toggle').addClass('ada-highlighted');
      const selectTime = e.currentTarget.innerText;
      if ($('.select-cabana').length) {
        $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-label', `Select Cabana: ${selectTime} selected`);
      } else {
        $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-label', `Select time: ${selectTime} selected`);
      }
      setTimeout(() => {
        $('.select-time-dropdown.dining .dropdown-toggle').focus();
      }, 100);
      $('.dropdown-menu button').removeClass('active');
      $.ajax({
        type: 'GET',
        url: '/shop/getUpdatedPriceForDining',
        contentType: 'application/json',
        data: { variantId: selectedVariantId }
      }).done((res) => {
        gfunctions.hideLoader();
        $('.diningErrorMsg').html('');
        const updatestock = $('#diningStock');
        updatestock.val(Number(res.stockLevel));
        if (Number(updatestock.val()) !== 0) {
          if (res.priceForAdult === res.priceForChild && (res.priceForAdult !== '' && res.priceForChild !== '')) {
            $('.price-per-person #personPrice').html(`<b>${res.priceForAdult}</b>`);
            $('.per-price').hide();
            $('.price-per-person').show();
            if (res.strikeOutAdultVariantPrice) {
              if ($('.price-per-person .strikeoutprice').length > 0) {
                $('.price-per-person .strikeoutprice').html(`<b>${res.strikeOutAdultVariantPrice}</b>`);
              } else {
                $('.price-per-person #personPrice').before(`<span class="strikeoutprice"><b>${res.strikeOutAdultVariantPrice}</b></span>`);
              }
            }
          } else if (res.priceForAdult !== '' && res.priceForChild === '') {
            $('.price-per-person #personPrice').html(`<b>${res.priceForAdult}</b>`);
            $('.per-price').hide();
            $('.price-per-person').show();
            if (res.strikeOutAdultVariantPrice) {
              if ($('.price-per-person .strikeoutprice').length > 0) {
                $('.price-per-person .strikeoutprice').html(`<b>${res.strikeOutAdultVariantPrice}</b>`);
              } else {
                $('.price-per-person #personPrice').before(`<span class="strikeoutprice"><b>${res.strikeOutAdultVariantPrice}</b></span`);
              }
            }
          } else {
            $('.per-price #adultPrice').html(`<b>${res.priceForAdult}</b>`);
            $('.per-price #childPrice').html(`<b>${res.priceForChild}</b>`);
            $('.per-price').show();
            $('.price-per-person').hide();
            if (res.strikeOutAdultVariantPrice && res.strikeOutChildVariantPrice) {
              if ($('.per-price .strikeoutprice').length > 0) {
                $('.price-per-adult .strikeoutprice').html(`<b>${res.strikeOutAdultVariantPrice}</b>`);
                $('.price-per-child .strikeoutprice').html(`<b>${res.strikeOutChildVariantPrice}</b>`);
              } else {
                $('.price-per-adult #adultPrice').before(`<span class="strikeoutprice"><b>${res.strikeOutAdultVariantPrice}</b></span`);
                $('.price-per-child #childPrice').before(`<span class="strikeoutprice"><b>${res.strikeOutChildVariantPrice}</b></span`);
              }
            }
          }
          $('#variantProductCode').val(res.variantId);
          $('.atc-dining').removeAttr('disabled');
          $('.sold-out').removeClass('show');
          $('.adult-child-wrap').show();
        } else {
          $('.adult-child-wrap').hide();
          $('.atc-dining').attr('disabled', 'disabled');
          $('.sold-out').addClass('show');
          $('.per-price').hide();
          $('.price-per-person').hide();
        }
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('Something went wrong in time-dropdown ajax');
      });
    });
  },
  addToCartDining() {
    $('body').on('click', '.atc-dining', (e) => {
      gfunctions.showLoader();
      const csrf = $('.atc-dining').data('csrf') ? $('.atc-dining').data('csrf') : $('#csrfSessionToken').data('csrf');
      const targetElement = $(e.target).data('hasvariants');
      const productCodePost = $('#variantProductCode').val();
      const adultVal = $('.adult-quantity-input').val();
      const childVal = $('.child-quantity-input').val();
      let selectedDay = '';
      let selectedTime = '';
      if ($('.select-day-dropdown.dining').length > 0) {
        selectedDay = $('.select-day-dropdown.dining #select-day')[0].dataset.selectedday;
      }
      if ($('.select-time-dropdown.dining').length > 0) {
        selectedTime = $('.select-time-dropdown.dining #select-time')[0].innerText;
      }
      const sendData = {
        productcode: productCodePost,
        daySelected: selectedDay,
        timeSelected: selectedTime,
        adultQty: adultVal,
        childQty: childVal
      };
      const pageType = $('#pagetype').data('pagetype');
      sendData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        sendData.productPosition = localStorage.getItem('productposition');
        sendData.pageNumber = localStorage.getItem('pageNumber');
        sendData.categoryName = localStorage.getItem('sascategorycode');
      }
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/dining/add',
          contentType: 'application/json',
          data: JSON.stringify(sendData),
          headers: {
            CSRFToken: csrf
          }
        }).done((response) => {
          gfunctions.hideLoader();
          if (response.diningError) {
            $('.diningErrorMsg').html(response.diningErrorText);
          } else if (response.addedToCart) {
            gfunctions.updateHeaderCartWidget(response);
            gfunctions.hideModal('diningAtcModal');
            CCL.addToCart.successModal(response);
            $('.diningErrorMsg').html('');
          }
        }).fail(() => {
          gfunctions.hideLoader();
          console.log('Something went wrong');
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-dining/pdp-dining.js